/** Like Alert, but only hides once dismissed */

import { useTheme } from '@mui/material/styles';
import Preact from 'preact';
import * as AlertComponent from './alert';

export type Props = {
    show: boolean;
    message: string;
    close: () => void;
    width: string;
    paddingTop?: number;
};

export function Component(props: Props) {
    const theme = useTheme();
    return (
        <AlertComponent.Component
            autoHideDuration={'disable'}
            show={props.show}
            message={props.message}
            close={props.close}
            width={props.width}
            paddingTop={props.paddingTop}
        />
    );
}
Component.displayName = 'PersistentAlert';
